(function(){
  var root=document.querySelector('.fxadv')||document.querySelector('.wrap')||document;
  var bar=root.querySelector('.fx-atc'); if(!bar) return;
  var btn=bar.querySelector('.fx-atc-btn');
  var ctas=Array.prototype.slice.call(root.querySelectorAll('a.cta'));
  if(!ctas.length) return;
  var last=ctas[ctas.length-1], ticking=false;
  function update(){
    ticking=false;
    var vh=window.innerHeight||document.documentElement.clientHeight, active=null, i;
    for(i=0;i<ctas.length;i++){ if(ctas[i].getBoundingClientRect().top<0) active=ctas[i]; }
    var lr=last.getBoundingClientRect(), lastVisible=(lr.top<vh && lr.bottom>0);
    if(active && active!==last && !lastVisible){
      var t=active.textContent.trim();
      if(btn.textContent!==t) btn.textContent=t;
      bar.classList.add('show');
    } else { bar.classList.remove('show'); }
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  update();
})();
